import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Abhishek Choudhary </span>
            from <span className="purple"> Jaipur, India.</span>
            <br />I am a DevOps engineer currently working with Microsoft + Nuance
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Watching Movies & TV Series
            </li>
            <li className="about-activity">
              <ImPointRight /> Exploring Tech World
            </li>
            <li className="about-activity">
              <ImPointRight /> Gymming
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "You must be the change you wish to see in the world."{" "}
          </p>
          <footer className="blockquote-footer">Mahatma Gandhi</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
